import { render, staticRenderFns } from "./FAQCategoryAdd.vue?vue&type=template&id=2466f1de"
import script from "./FAQCategoryAdd.vue?vue&type=script&lang=js"
export * from "./FAQCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports